export default "__VITE_ASSET__D4Q0TAqs__"